export default {
  userSuggestion: [],
  workspace: [],
  user: [],
  goal: [],
  feedback: [],
};
